import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the animated filter
 * @param {boolean} animated - Whether to filter for animated models
 */
export const setAnimated = (animated) => {
  searchPageStore.setState({ animated })
}

/**
 * Sets the pbr filter
 * @param {boolean} pbr - Whether to filter for PBR models
 */
export const setPbr = (pbr) => {
  searchPageStore.setState({ pbr })
}

/**
 * Sets the rigged filter
 * @param {boolean} rigged - Whether to filter for rigged models
 */
export const setRigged = (rigged) => {
  searchPageStore.setState({ rigged })
}

/**
 * Sets the game-ready filter
 * @param {boolean} gameReady - Whether to filter for game-ready models
 */
export const setGameReady = (gameReady) => {
  searchPageStore.setState({ gameReady })
}

/**
 * Sets the has-renders filter
 * @param {boolean} withRenders - Whether to filter for models that include renders
 */
export const setWithRenders = (withRenders) => {
  searchPageStore.setState({ withRenders })
}

/**
 * Clears all threeDOnly filters (sets all to false)
 */
export const clearThreeDOnly = () => {
  searchPageStore.setState({
    animated: DEFAULT_STATE.animated,
    pbr: DEFAULT_STATE.pbr,
    rigged: DEFAULT_STATE.rigged,
    gameReady: DEFAULT_STATE.gameReady,
    withRenders: DEFAULT_STATE.withRenders,
  })
}
